import styles from "./index.module.css";
import MachineGPT from "../machineGPT/index.jsx";

import GinaAlert from "./gina_content_holder";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
function GinaTemplate({ children, action, loading, maximize }) {
  const location = useLocation();
  const [wording, setWording] = useState("");
  const [checked, setChecked] = useState(false);
  const [ginaActive, setGinaActive] = useState(false);
  useEffect(() => {
    setGinaActive(maximize);
  }, [maximize]);
  function toggleCallOut() {
    setGinaActive(!ginaActive);
    setChecked(false);
  }
  const tooltip = (word) => (
    <Tooltip id="tooltip">
      <strong>{word}</strong>
    </Tooltip>
  );
  useEffect(() => {
    // setGinaActive(false);
  }, [location]);
  // useEffect(() => {
  //   const getCallout = localStorage.getItem("gina_callout");
  //   if (callout && getCallout === "1") {
  //     setWording(callout);
  //     setChecked(true);
  //   } else {
  //     setWording("");
  //     setChecked(false);
  //   }
  // }, [callout]);
  return (
    <>
      <div className={styles.ginaPlaceholder}>
        <div
          onClick={() => {
            // toggleCallOut();
            setChecked(false);
          }}
          style={{
            transformOrigin: "bottom right",
            display: checked && !ginaActive ? "block" : "none",
          }}
          {...(checked ? { timeout: 1000 } : {})}
        >
          <div className={styles.ginaCallOut}>
            <div
              className={styles.closePopover}
              onClick={() => {
                setChecked(false);
              }}
            >
              x
            </div>
            {wording}{" "}
            {loading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
        </div>
        <div in={!ginaActive}>
          {!ginaActive ? (
            <div
              className={"beta-badge"}
              style={{
                zIndex: 10,
                position: "absolute",
                left: "-42px",
                bottom: "67px",
              }}
            >
              BETA
            </div>
          ) : null}

          <img
            onClick={toggleCallOut}
            className={styles.gina}
            src="/img/ai_face_big.png"
          />
        </div>
        <div
          in={ginaActive}
          style={{
            transitionDelay: ginaActive ? "200ms" : "0ms",
          }}
          {...(ginaActive ? { timeout: 100 } : {})}
        >
          <div className={ginaActive ? styles.ginaCallout : styles.hiddenGina}>
            <div
              in={ginaActive}
              style={{ transitionDelay: ginaActive ? "220ms" : "0ms" }}
            >
              <img
                onClick={toggleCallOut}
                className={`${styles.ginaActive} ${styles.gina}`}
                src="/img/ai_face_big.png"
              />
            </div>
            {ginaActive && (
              <div
                style={{
                  marginLeft: "80px",
                  fontWeight: "bold",
                  marginTop: "-8px",
                }}
              >
                <div style={{ color: "#d3d3d3", display: "flex" }}>
                  GINA
                  {ginaActive ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={tooltip(
                        "This Chat is in BETA: I can only answer general questions for now! Once I’ve been upgraded, I’ll be more capable to even analyze and answer questions related to your machine manuals and more!"
                      )}
                    >
                      <div
                        className={"beta-badge"}
                        style={{ marginLeft: "10px" }}
                      >
                        BETA <i className={"fa fa-info-circle"}></i>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                </div>
                <div style={{ color: "#ababab", fontSize: "14px" }}>
                  AI Assistant
                </div>
              </div>
            )}

            <div className={styles.minimize} onClick={toggleCallOut}>
              minimize
            </div>
            <div
              className="white-text"
              style={{
                marginTop: "-10px",
                padding: "10px",
              }}
            >
              <div className="alert-text">
                <GinaAlert minimize={toggleCallOut} url={action}>
                  {ginaActive && <MachineGPT />}
                </GinaAlert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GinaTemplate;
